import React from 'react';

function EditDayWiseAvail() {
  return (
    <div>
      <p>Edit Day wise avail</p>
    </div>
  );
}

export default EditDayWiseAvail;
